import React from "react";
import { DatePicker } from "antd";
import { FormGroup, FormLabel } from "react-bootstrap";

import "../styles.css";

const { RangePicker } = DatePicker;

const CustomDatePicker = ({
  id,
  label,
  width = "15%",
  onInputChange,
  isRangePicker,
  value,
}) => {
  return (
    <div style={{ width: width }}>
      <FormGroup>
        <FormLabel htmlFor={`input-datePicker-${id}`}>{label}</FormLabel>
        {isRangePicker ? (
          <RangePicker
            id={`input-datePicker-${id}`}
            onChange={(date) => onInputChange(date, id)}
            value={value}
          />
        ) : (
          <DatePicker
            id={`input-datePicker-${id}`}
            onChange={(date) => onInputChange(date, id)}
            value={value}
          />
        )}
      </FormGroup>
    </div>
  );
};

export default CustomDatePicker;
